<template>
    <sub-page id="viewPlanDetail" :fullPage="true">
        <div class="plan-detail-panel clearfix">

            <div class="plan-left-content">
                <transition enter-active-class="animated slideInDown" >
                    <div class="plan-basic-info">
                        <div class="basic-title">
                            <h3 class="title" :title="basicInfo.name">
                                <span class="plan-status"
                                      :class="basicInfo.status">{{basicInfo.statusName}}</span>
                                <span>{{basicInfo.name}}</span>
                            </h3>
                            <div class="operate-wrap">
                                <span class="operate" :title="$t('train.clonePlan')" @click="clonePlan(basicInfo.name)"><i class="nucfont inuc-clone"></i></span>
                            </div>
                        </div>

                        <div class="basic-content">
                            <div class="basic-col">
                                <div class="basic-item">
                                    <h5>培训专题：</h5><p>{{basicInfo.specialName || "-"}}</p>
                                </div>
                                <div class="basic-item">
                                    <h5>{{$t('train.type')}}：</h5><p>{{basicInfo.typeName}}</p>
                                </div>
                                <div class="basic-item">
                                    <h5>{{$t('c.operatorLevel')}}：</h5><p>{{basicInfo.forLevelName}}</p>
                                </div>
                            </div>

                            <div class="basic-col">
                                <div class="basic-item">
                                    <h5>{{$t('c.startTime')}}：</h5><p>{{formatDate(2, basicInfo.startTime)}}</p>
                                </div>
                                <div class="basic-item">
                                    <h5>{{$t('c.endTime')}}：</h5><p>{{formatDate(2, basicInfo.endTime)}}</p>
                                </div>
                                <div class="basic-item">
                                    <h5>{{$t('train.preTime')}}：</h5><p>{{formatDate(2, basicInfo.prePublishTime)}}</p>
                                </div>
                            </div>

                            <div class="basic-col">
                                <div class="basic-item">
                                    <h5>{{$t('c.creator')}}：</h5><p>{{basicInfo.creatorName || "-"}}</p>
                                </div>
                                <div class="basic-item">
                                    <h5>{{$t('c.examType')}}：</h5><p>{{basicInfo.formName}}</p>
                                </div>
                                <div class="basic-item">
                                    <h5>电子签名：</h5><p :title="basicInfo.place">{{basicInfo.isNeedSignature?'开启':"关闭"}}</p>
                                </div>
                            </div>

                            <div class="basic-col">
                                <div class="basic-item">
                                    <h5>{{$t('train.classHour')}}：</h5><p>{{basicInfo.hours || "-"}}</p>
                                </div>
                                <div class="basic-item">
                                    <h5>{{$t('train.classScore')}}：</h5><p>{{basicInfo.credit || "-"}}</p>
                                </div>
                                <div class="basic-item">
                                    <h5>{{$t('train.site')}}：</h5><p :title="basicInfo.place">{{basicInfo.place || "-"}}</p>
                                </div>
                            </div>

                            <div class="basic-col basic-col-full" v-if="basicInfo.content">
                                <div class="basic-item">
                                    <h5>{{$t('train.content')}}：</h5><p :title="basicInfo.content">{{basicInfo.content}}</p>
                                </div>
                            </div>

                            <div class="basic-col basic-col-full">
                                <div class="basic-item">
                                    <h5>{{$t('train.progress')}}：</h5>
                                    <p :title="basicInfo.content">
                                        <el-progress
                                            :stroke-width="20"
                                            :percentage="basicInfo.percent&&basicInfo.percent*100"
                                            style="flex: 1;padding-right: 20px;padding-top: 2px;"
                                            :text-inside="true"
                                        >
                                        </el-progress>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <div class="plan-users">
                    <div class="plan-user-title">
                        <div class="panel-icon"><i class="nucfont inuc-members"></i></div>
                        <span class="panel-title">{{$t('train.trainees')}}</span>
                        <el-input class="user-search" v-model="filters[0].value" placeholder="输入姓名快速查询" size="mini" clearable></el-input>

                        <el-button v-if="(userInfo.type===1 || userInfo.userID==basicInfo.creatorID)" class="user-operate" @click="addUser"
                                   type="text" :title="$t('c.add')"><i class="nucfont inuc-import-user"></i>
                        </el-button>
                        <el-button class="user-operate" @click="enlargeLayout" style="right: 20px;"
                                   type="text" :title="$t('train.enlarge')">
                            <i class="nucfont" :class="enlarge ? 'inuc-arrow-down': 'inuc-arrow-up'"></i>
                        </el-button>
                    </div>
                    <data-tables class="form-table"
                                 ref="trainTable"
                                 :data="filterData"
                                 :table-props="tableProps"
                                 :page-size="20"
                                 :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                 :filters="filters"
                                 @filter-change="filterChange"
                    >

                        <!-- column title -->
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                         :key="title.label"
                                         align="center"
                                         sortable="custom">
                        </el-table-column>

                        <el-table-column prop="statusName" :label="$t('c.status')" align="center"
                                         column-key="status"
                                         :filters="filterRules"
                                         :filter-method="filterTag"
                                         filter-placement="bottom-end">
                            <template slot-scope="scope">
                                <el-popover
                                    :disabled="scope.row.status!==3 && scope.row.status!==4"
                                    ref="popover"
                                    placement="right"
                                    :title="$t('train.absentReason')"
                                    width="200"
                                    trigger="hover"
                                    :content="scope.row.reason">
                                    <span class="plan-status" :class="getStatus(scope.row.status)" slot="reference">
                                       {{scope.row.statusName}}
                                    </span>
                                </el-popover>
                            </template>
                        </el-table-column>

                        <el-table-column :label="$t('c.operation')" align="center"
                                         v-if="(userInfo.type===1 || userInfo.userID==basicInfo.creatorID)">
                            <div class="btn-cell" slot-scope="scope">
                                <i class="nucfont inuc-remove-user"
                                   :title="$t('train.delTrainee')"
                                   @click="removeUser(scope.row)"></i>
                            </div>
                        </el-table-column>
                    </data-tables>
                </div>
            </div>

            <div class="plan-right-content">
                <ui-panel class="plan-course-paper" :title="$t('train.courseSystem')" icon="inuc-folder">
                    <div class="timeline-container">
                        <ul>
                            <template v-for="(item, index) in coursePaper">
                                <!-- 考卷 -->
                                <li class="timeline-block-paper" v-if="item.paperID" :key="index">
                                    <div class="timeline-block timeline-paper">
                                        <div class="timeline-icon" @click="previewPaper(item)">
                                            <i class="nucfont inuc-kaoshijilu"></i>
                                        </div>
                                        <div class="timeline-content">
                                            <p class="title">
                                                <label>{{$t('paper.name')}}</label>：<span>{{item.paperName}}</span></p>
                                            <p class="course-type">
                                                <label>{{$t('paper.type')}}</label>：<span>{{item.paperTypeName || "-"}}</span>
                                            </p>
                                            <!-- 职鉴：考试模式 -->
                                            <p v-if="item.paperType === 5">
                                                <label>考试模式</label>：<span>{{ item.isSimulationMode ? '走图': '单题' }}</span>
                                            </p>
                                            <p class="know-point">
                                                <label>{{$t('c.knowledgePoint')}}</label>：<span>{{item.paperKnowledgeName || "-"}}</span>
                                            </p>
                                            <p class="pap-time">
                                                <label>{{$t('paper.testPeriod')}}</label>：<span>{{item.duration || "-"}}</span>
                                            </p>
                                            <p>
                                                <label>{{$t('paper.disorder')}}</label>：<span>{{item.disorder ? $t('c.yes') : $t('c.no')}}</span>
                                            </p>
                                            <p v-if="item.resit">
                                                <label>{{$t('paper.allowResitTimes')}}</label>：<span>{{item.resit}}</span>
                                            </p>
                                            <p class="pap-is-key">
                                                <label>{{$t('paper.allowReview')}}</label>：<span>{{item.allowReview ? $t('c.yes') : $t('c.no')}}</span>
                                            </p>
                                            <p class="pap-answer-ptime" v-if="item.allowReview">
                                                <label>{{$t('paper.publishTime')}}</label>：<span>{{item.deadline ? formatDate(2, item.deadline) : $t('paper.showAnswerAfterExam')}}</span>
                                            </p>
                                            <p v-if="item.isAntiCheating">
                                                <label>{{ $t('paper.faceMatching') }}</label>：<span>{{ $t('c.enabled') }}</span>
                                            </p>
                                            <p v-if="item.isMonitor">
                                                <label>{{ $t('paper.photoDuration') }}</label>：<span>{{item.photoDuration}}{{ $t('paper.secondPerTime') }}</span>
                                            </p>
                                            <p class="hours" v-if="item.hours">
                                                <label>{{$t('train.hour')}}</label>：<span>{{item.hours}}</span>
                                            </p>
                                            <p class="credit" v-if="item.credit">
                                                <label>{{$t('train.credit')}}</label>：<span>{{item.credit}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>

                                <!-- 模拟考卷 -->
                                <li class="timeline-block-paper" v-if="item.mockPaperID" :key="index">
                                    <div class="timeline-block timeline-mockPaper">
                                        <div class="timeline-icon" @click="previewPaper(item)">
                                            <i class="nucfont inuc-kaoshijilu"></i>
                                        </div>
                                        <div class="timeline-content">
                                            <p class="title">
                                                <label>{{$t('paper.mock')}}</label>：<span>{{item.mockPaperName}}</span></p>
                                            <p class="course-type">
                                                <label>{{$t('paper.type')}}</label>：<span>{{item.mockPaperTypeName || "-"}}</span>
                                            </p>
                                            <!-- 职鉴：考试模式 -->
                                            <p v-if="item.mockPaperType === 5">
                                                <label>考试模式</label>：<span>{{ item.isSimulationMode ? '走图': '单题' }}</span>
                                            </p>
                                            <p class="know-point">
                                                <label>{{$t('c.knowledgePoint')}}</label>：<span>{{item.mockPaperKnowledgeName || "-"}}</span>
                                            </p>
                                            <p class="pap-time">
                                                <label>{{$t('paper.testPeriod')}}</label>：<span>{{item.duration || "-"}}</span>
                                            </p>
                                            <p class="pass-line" v-if="item.passLine">
                                                <label>{{$t('topic.mockPassLine')}}</label>：<span>{{item.passLine}}</span>
                                            </p>
                                            <p class="hours" v-if="item.hours">
                                                <label>{{$t('train.hour')}}</label>：<span>{{item.hours}}</span>
                                            </p>
                                            <p class="credit" v-if="item.credit">
                                                <label>{{$t('train.credit')}}</label>：<span>{{item.credit}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>

                                <!-- 课件 -->
                                <li class="timeline-block-course" v-if="item.courseID" :key="item.id">
                                    <div class="timeline-block timeline-course">
                                        <div class="timeline-icon" @click="previewCourseware(item)">
                                            <i class="nucfont inuc-folder-ppt"></i>
                                        </div>
                                        <div class="timeline-content">
                                            <p class="title">
                                                <label>{{$t('course.name')}}</label>：<span>{{item.courseName || "-"}}</span>
                                            </p>
                                            <p class="course-type">
                                                <label>{{$t('course.type')}}</label>：<span>{{item.courseTypeName || "-"}}</span>
                                            </p>
                                            <p class="know-point">
                                                <label>{{$t('c.knowledgePoint')}}</label>：<span>{{item.courseKnowledgeName || "-"}}</span>
                                            </p>
                                            <p class="hours" v-if="item.hours">
                                                <label>{{$t('train.hour')}}</label>：<span>{{item.hours}}</span>
                                            </p>
                                            <p class="credit" v-if="item.credit">
                                                <label>{{$t('train.credit')}}</label>：<span>{{item.credit}}</span>
                                            </p>
                                            <p class="credit" v-if="item.intervalTime">
                                                <label>弹窗设置</label>：<span>{{item.intervalTime}}秒</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>

                                <!-- 调查问卷 -->
                                <li class="timeline-block-course" v-if="item.businessType === 4" :key="item.id">
                                    <div class="timeline-block timeline-survey">
                                        <div class="timeline-icon" @click="previewSurvey(item)">
                                            <i class="nucfont inuc-feedback"></i>
                                        </div>
                                        <div class="timeline-content">
                                            <p class="title">
                                                <label>问卷名称</label>：<span>{{item.businessName || "-"}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </ui-panel>
            </div>

            <!-- trainee dialog -->
            <trainee-dialog :traineeDialog.sync="traineeDialog"
                            :selectedTable="tableData"
                            @dialog-save="dialogSave"
            ></trainee-dialog>

            <el-dialog :title="$t('train.clonePlan')"
                       :visible.sync="dialogClone"
                       width="510px"
                       :close-on-click-modal="false"
                       :modal-append-to-body="false">
                <el-form :model="dialogForm" ref="dialogForm"
                         style="margin-right: 40px;"
                         label-width="140px">
                    <el-form-item :label="$t('train.name')+'：'">
                        <el-input v-model="dialogForm.name" :placeholder="$t('tip.name')" clearable></el-input>
                    </el-form-item>
                </el-form>
                <div class="clone-tip">
                    <p>{{$t('train.extendRule')}}: </p>
                    <p>1. {{$t('train.cloneTip1')}}</p>
                    <p>2. {{$t('train.cloneTip2')}}</p>
                </div>
                <div slot="footer" style="text-align: center;margin-top: -10px;">
                    <el-button type="primary" @click="cloneSave('dialogForm')">{{$t('c.save')}}</el-button>
                </div>
            </el-dialog>
        </div>

        <!-- 理论考卷 -->
        <router-view></router-view>

        <!-- 图像全屏查看 -->
        <full-screen
            ref="nstswrap"
            :src="src"
            :isShow="isShow"
            :showCloseBtn="false"
            @changeIsShow="toggleIsShow"
        />

        <!-- 理论课件查看 -->
        <course-preview :isShow="isPreviewCourse" :courseID="courseid" v-on:courseExit="courseIsExit"
                        ref="theoryCourse"/>

        <!--查看调研问卷-->
        <survey-view v-if="isViewSurveyPaper"
                     :surveyInfo="surveyInfo"
                     @close="closeSurvey"></survey-view>

    </sub-page>
</template>

<script>
import api from '@/api';
import config from '@/config'
import {Ticket, screenfull} from '@/utils';
import SubPage from '@/components/Subpage'
import uiPanel from '@/components/UIPanel';
import FullScreen from '@/components/FullScreen';
import traineeDialog from '@/components/Dialog/TraineeDialog'
import CoursePreview from '@/pages/Course/CoursePreview';
import SurveyView from '@/pages/Survey/SurveyView';

export default {
    props: ['planId'],
    components: {
        SubPage,
        uiPanel,
        screenfull,
        FullScreen,
        CoursePreview,
        SurveyView,
        traineeDialog
    },
    data() {
        return {
            enlarge: false,
            userInfo: {},
            isShow: false,
            src: null,
            courseid: '0',
            isPreviewCourse: false,
            isViewSurveyPaper: false,
            surveyInfo: {},
            basicInfo: {},
            coursePaper: {},
            tableData: [],
            filterData: [],
            tableProps: {
                border: false,
                stripe: true,
                height: "auto",
            },
            titles: [
                {
                    prop: 'userName',
                    label: this.$t('c.username')
                }, {
                    prop: 'accountNo',
                    label: this.$t('c.account')
                }, {
                    prop: 'orgName',
                    label: this.$t('c.organizations')
                }, {
                    prop: 'postName',
                    label: this.$t('c.position')
                }, {
                    prop: 'gradeName',
                    label: this.$t('c.grade')
                }
            ],
            filters: [
                {
                    prop: 'userName',
                    value: ''
                }
            ],

            traineeDialog: false,

            // 培训状态status：0未开始，1进行中，2完成，3缺席，4恢复
            filterRules: [
                {text: this.$t('count.notStart'), value: 0},
                {text: this.$t('count.processing'), value: 1},
                {text: this.$t('count.finish'), value: 2},
                {text: this.$t('count.absence'), value: 3},
                {text: this.$t('count.recover'), value: 4},
            ],
            dialogClone:false,
            dialogForm:{
                name:''
            }
        }
    },
    mounted() {
        if (Ticket.get()) {
            this.userInfo = Ticket.get();
        }

        this.getTrainData().then(() => {
            this.initDomEvent();
        })

        //this.getDialogUsers();
    },
    methods: {
        enlargeLayout() {
            let $info = $('.plan-basic-info');
            this.enlarge = !this.enlarge;

            if (this.enlarge) {
                $info.slideUp();
            } else {
                $info.slideDown();
            }
        },
        filterChange(filters) {
            this.filterStatus = filters.status;

            if (!this.filterStatus?.length) {
                this.filterData = [...this.tableData];
                return
            }

            this.filterData = [];
            this.filterStatus.forEach(v => {
                this.filterData.push(...this.tableData.filter(item => item.status === v));
            })
        },
        filterTag(value, row) {
            return true;
        },

        getTrainData() {
            return api.getTrainingDetail(this.planId).then(res => {
                let data = res.package;

                //基本信息处理
                data.status = this.getStatus(data.status);

                this.basicInfo = data;

                //课程信息
                this.coursePaper = data.processes;
                data.trainees.forEach(item => {
                    item.postName = item.postName ? item.postName : '';
                    item.gradeName = item.gradeName ? item.gradeName : '';
                });
                //人员信息
                this.tableData = data.trainees;
                this.filterData = [...data.trainees];

                //this.$refs.trainTable.$refs.elTable.clearFilter();
            });
        },

        addUser() {
            this.traineeDialog = true;
        },
        dialogSave(users) {
            let selectedUsers = users.map(item => item.id);

            this.tableData.forEach(val => {
                let idx = selectedUsers.indexOf(val.userID);
                if (idx > -1) {
                    selectedUsers.splice(idx, 1);
                }
            });

            if (!selectedUsers.length) {
                this.traineeDialog = false;
                return
            }

            api.addTrainingMembers(this.planId, {
                userIDs: selectedUsers
            }).then(res => {
                this.traineeDialog = false;
                this.success(this.$t('m.addSuccess'));

                this.getTrainData().then(() => {
                    if (this.filterStatus?.length) {
                        this.filterChange({status: this.filterStatus})
                    }
                })
            })
        },

        removeUser(data) {
            this.$confirm(this.$t('train.delTraineeConfirm', [data.userName]), this.$t('m.tip'), {
                type: 'warning'
            }).then(() => {
                api.removeTrainingMember(this.planId, {
                    userID: data.userID
                }).then(res => {
                    this.$t('m.operateSuccess')

                    this.getTrainData().then(() => {
                        if (this.filterStatus?.length) {
                            this.filterChange({status: this.filterStatus})
                        }
                    })
                });
            }).catch(() => {
            });
        },

        formatDate(timetype, data){
            let date;
            if (data) {
                if (timetype == 2) {
                    date = data.substring(0, 10) + " " + data.substring(11, 16)
                } else {
                    date = data.substring(0, 10)
                }
            } else {
                date = '-'
            }
            return date;
        },
        getStatus(status) {
            return [
                'notStart',     //0 未开始
                'processing',   //1 进行中
                'finish',       //2 完成
                'absence',      //3 缺席
                'recover',      //4 恢复
            ][status]
        },
        //克隆培训计划
        clonePlan(name){
            this.dialogClone=true;
            this.dialogForm.name=name;
        },
        //克隆培训计划保存
        cloneSave(){
            api.cloneOnline(this.planId,this.dialogForm).then((res)=>{
                this.$message({
                    type: 'success',
                    message: this.$t('train.cloneSuccess')
                });
                this.dialogClone=false;
                this.$emit('onClose');
                this.$router.replace({name: 'trainPlan'})
            }).catch(error => this.roleLoading = false)
        },
        // 考卷查看
        previewPaper({paperID, paperType, mockPaperID, mockPaperType}) {
            let _paperID = paperID || mockPaperID;
            let _paperType = paperType || mockPaperType;

            switch (_paperType) {
                case 1:
                    this.$router.push({name: 'trainPlanDetailPaper', params: {paperId: _paperID}});
                    screenfull.request();
                    break;
                case 3:
                    this.isShow = !this.isShow
                    this.src = `${api.imagePanoramicHost}/ctPaperDetail?paperId=${_paperID}&lang=${this.$i18n.locale}`
                    // this.src = `/static/3D/CT_base.html?type=PAPER_PREVIEW&paperID=${paperID}`
                    this.$refs.nstswrap.fullScreen()
                    break
                case 4:
                    this.isShow = !this.isShow
                    this.src = `${api.imagePanoramicHost}/drPaperDetail?paperId=${_paperID}&lang=${this.$i18n.locale}`
                    // this.src = `/static/3D/DR_base.html?type=PAPER_PREVIEW&paperID=${paperID}`
                    this.$refs.nstswrap.fullScreen()
                    break
                case 5:
                    // todo: 查看职鉴考卷
                    this.$router.push({name: 'paperPreview',params: {paperId: _paperID}, query: {isFiscan: true}});
                    screenfull.request();
                    break
                default:
                    break
            }
        },
        // 课件查看
        previewCourseware ({courseID, courseType}) {
            switch (courseType) {
                case 1:
                    this.courseid = courseID
                    this.isPreviewCourse = !this.isPreviewCourse
                    this.$refs.theoryCourse.fullScreen()
                    break
                case 3:
                    this.isShow = !this.isShow
                    this.src = `${api.imagePanoramicHost}/ctCourseDetail?courseId=${courseID}&lang=${this.$i18n.locale}`
                    // this.src = `/static/3D/CT_base.html?type=COURSE_PREVIEW&courseID=${courseID}`
                    this.$refs.nstswrap.fullScreen()
                    break
                case 4:
                    this.isShow = !this.isShow
                    this.src = `${api.imagePanoramicHost}/drCourseDetail?courseId=${courseID}&lang=${this.$i18n.locale}`
                    // this.src = `/static/3D/DR_base.html?type=COURSE_PREVIEW&courseID=${courseID}`
                    this.$refs.nstswrap.fullScreen()
                    break
                default:
                    break
            }
        },
        // 查看问卷
        previewSurvey({businessId}) {// 查看
            screenfull.request();
            this.isViewSurveyPaper = true;

            this.$api.getQuestionnaireDetail(businessId).then(res => {
                let data = res.package
                this.surveyInfo = data.template
                this.surveyInfo.name = data.name
            }).catch(() => {
                screenfull.exit();
            })
        },
        closeSurvey() {
            this.isViewSurveyPaper = false;
        },
        // 图像考卷预览
        toggleIsShow (val) {
            this.isShow = val;
            this.src = null
        },
        // 理论课件查看
        courseIsExit(val) {
            this.isPreviewCourse = val
        },
        success(msg) {
            this.$message({
                message: msg,
                type: 'success'
            })
        },

        initDomEvent() {
            // 文本溢出显示title
            this.$nextTick(() => {
                $('.timeline-content').on('mouseenter', 'p', function () {
                    let width = this.clientWidth;
                    let fullWidth = this.scrollWidth;

                    if (width < fullWidth) {
                        $(this).attr('title', $(this).text())
                    } else {
                        $(this).removeAttr('title')
                    }
                })
            })
        }
    },
    destroyed(){
        this.$emit('onClose');
    },
}
</script>

<style scoped lang="scss">
@import '../../style/const.scss';

.plan-detail-panel {
    height: 100%;
    padding-bottom: 25px;
}

.plan-left-content {
    float: left;
    display: flex;
    flex-direction: column;
    width: 70%;
    height: 100%;
    padding: 0 10px;
}

.plan-right-content {
    width: 30%;
    float: left;
    height: 100%;
    padding: 0 10px;
}

.plan-basic-info {
    margin-bottom: 10px;
}

.basic-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .title {
        font-size: 18px;
        @include no-wrap()
    }

    .plan-status {
        margin-right: 8px;
        padding: 4px 12px;
        width: auto;
        font-size: 12px;
        border-radius: 4px;
        vertical-align: bottom;
    }

    .operate-wrap {
        flex-shrink: 0;
        .operate {
            cursor: pointer;
            color: #999;
            + .operate {
                margin-left: 15px;
            }
            &:hover {
                color: $blue;
            }
            >i{
                font-size: 20px;
            }
        }
    }
}

.basic-content {
    .basic-col {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .basic-item {
            width: 33%;
            flex-shrink: 0;
        }
    }

    .basic-col-full {
        .basic-item {
            width: 100%;
        }
    }

    .basic-item {
        display: flex;
        align-items: center;
        h5 {
            flex: 0 0 100px;
            text-align: right;
        }
        p {
            flex: 1;
            padding-left: 4px;
            color: #676a6c;
            @include no-wrap();
        }
    }
}

.plan-users {
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid $c-border;

    .plan-user-title {
        display: flex;
        position: relative;
        height: 40px;
        background-color: #f4f3f8;
        line-height: 40px;
        border-bottom: 1px solid $c-border;
        .panel-icon {
            width: 45px;
            height: 40px;
            border-right: 1px solid $c-border;
            text-align: center;
            color: #1c84c6;
            line-height: 40px;
            .nucfont {
                font-size: 20px
            }
        }
        .panel-title {
            padding-left: 15px;
            vertical-align: 2px;
        }
        .user-search {
            margin-left: 20px;
            width: 200px;
        }
        .user-operate {
            position: absolute;
            right: 60px;
            padding-top: 10px;
            padding-bottom: 10px;
            margin-left: 10px;
            color: #a3a4a9;
            &:hover {
                color: #188ae2;
            }
            .nucfont {
                font-size: 20px;
            }
        }
    }

    .user-text {
        background-color: #fff;
        color: #1c84c6;
        padding: 3px 25px 14px;
        border-top: 3px solid #1c84c6;
        font-size: 16px;
        border-left: 1px solid $c-border;
        border-right: 1px solid $c-border;
    }
}

.form-table {
    display: flex;
    padding-bottom: 20px;
    flex: 1;
    flex-direction: column;
}

.plan-course-paper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.plan-status {
    display: inline-block;
    color: #fff;
    width: 70px;
    border-radius: 2px;
    font-size: 14px;
    text-align: center;

    &.status {
        background-color: #23b7e5;
    }
    &.notStart {
        background-color: #2e7faa;
    }
    &.processing {
        background-color: #0396a6;
    }
    &.finish {
        background-color: #FFB822;
    }
    &.absence {
        background-color: #8c7b6c;
    }
    &.recover {
        background-color: #c47a76;
    }
}

/*****时间轴****/
.timeline-container {
    position: relative;
    width: 90%;
    margin: 0 auto;
    font-size: 13px;
    &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: -10px;
        left: 26px;
        border-left: 1px dashed #ccc;
    }

    .timeline-block {
        position: relative;
        &:after {
            content: '';
            position: absolute;
            bottom: -5px;
            left: 20px;
            width: 12px;
            height: 12px;
            background-color: #fff;
            border: 1px solid #ccc;
            border-radius: 50%;
        }

        .timeline-icon {
            position: absolute;
            top: 50%;
            left: 0;
            width: 56px;
            height: 56px;
            transform: translateY(-50%);
            text-align: center;
            color: #fff;
            border: 3px solid;
            border-radius: 50%;
            cursor: pointer;

            &:hover {
                box-shadow: 0 4px 8px rgba(0, 0, 0, .5);
            }

            > .nucfont {
                font-size: 24px;
                vertical-align: -20px;
            }
        }

        .timeline-content {
            position: relative;
            margin-left: 80px;
            background: #fff;
            color: #676a6c;
            border: solid 1px $c-border;
            border-bottom: none;

            > p {
                padding: 5px 15px;
                @include no-wrap;
            }
            &:hover {
                background-color: #faf9fc;
                &:after {
                    content: '';
                    position: absolute;
                    top: 42%;
                    right: 100%;
                    height: 0;
                    width: 0;
                    border: 14px solid transparent;
                    border-right: 14px solid #faf9fc;
                }
                &:before {
                    content: '';
                    position: absolute;
                    top: 42%;
                    right: 100%;
                    height: 0;
                    width: 0;
                    margin-right: 1px;
                    border: 14px solid transparent;
                    border-right: 14px solid $c-border;
                }
            }
        }
    }

    ul li:last-child {
        .timeline-content {
            border-bottom: 1px solid $c-border;
        }
    }
}

.timeline-course .timeline-icon {
    background-color: $c-course;
    border-color: #e0f4ff !important;
}

.timeline-paper .timeline-icon {
    background-color: $c-paper;
    border-color: #fff3e6 !important;
}

.timeline-mockPaper .timeline-icon {
    background-color: $c-mock;
    border-color: #c9fdf3 !important;
}

.timeline-survey {
    .timeline-icon {
        background-color: $c-survey;
        border-color: tint($c-survey, 20%) !important;
    }
    .timeline-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 90px;
    }
}

.app-root:not(.lang-zh-CN) {
    .basic-item h5 {
        flex: 0 0 120px;
    }
    .basic-content {
        font-size: 12px;
    }
    .timeline-container {
        font-size: 12px;
    }
    .plan-users .plan-status {
        width: 100px;
        font-size: 12px;
    }
}

@media screen and (max-width: 1366px) {
    .plan-detail-panel {
        padding-bottom: 0;
    }
}
.clone-tip{
    margin-left: 58px;
    color: #9f9f9f;
    margin-bottom: 20px;
    >p{
        line-height: 26px;
    }
}
</style>

<style lang="scss">
#viewPlanDetail {
    .el-card__body {
        padding-top: 20px;
    }

    .user-dialog {
        min-width: 860px;
    }

    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
        background-color: #bbb;

        &:after {
            border-color: #fff;
        }
    }

    .plan-users {
        min-height: 0;
        .sc-table {
            min-height: 0;
            padding-bottom: 10px;
            thead > tr > th {
                background-color: #fff;
            }
        }
    }
}
</style>
